import React, { useContext, useEffect, useState } from 'react';
import { auth, db, storage } from '../firebase';
import image from '../img/dp.png';

interface CurrentUser {
  email: string;
  password: string;
  username: string;
  uid: string;
}

interface AuthContextValue {
  currentUser: CurrentUser;
  signup: Function;
  login: Function;
  logout: Function;
  resetPassword: Function;
}

export const AuthContext = React.createContext({} as AuthContextValue);

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  function signup(email, password, firstName, lastName) {
    return auth
      .createUserWithEmailAndPassword(email, password)
      .then((cred) => {
        db.collection('profile')
          .doc(cred.user.uid)
          .set({
            firstName: firstName,
            lastName: lastName,
            qualifications: [],
            experiences: [],
            activities: [],
            contribution: [],
            description: '',
            positions: [],
            current_position: 'Team Member',
            function: '',
            facebook: '',
            instagram: '',
            linkedIn: '',
            role: 'viewer',
            email: email,
            dp_url: '',
          })
          .then();
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });
  }
  function login(email, password) {
    return auth.signInWithEmailAndPassword(email, password);
  }

  function logout() {
    return auth.signOut();
  }

  function resetPassword(email) {
    return auth.sendPasswordResetEmail(email);
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout,
    resetPassword,
  };
  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
}
